<div class='info-list-item' *ngIf='isValid'>
  <div class='label'>
    <ng-container *ngIf='labelTooltip'>
      <info-tooltip [title]='labelTooltip'></info-tooltip>
    </ng-container>
    <span *ngIf='!( labelInteract.observers.length && enableLabelInteract )'>
      {{ label }}
    </span>
    <a *ngIf='labelInteract.observers.length && enableLabelInteract' class='btn btn-link p-0'
      (click)='labelInteract.emit( item )'>
      {{ label }}
    </a>
  </div>
  <div class='value' enAnonLock>
    <span class='value-content' enTooltip data-placement="top"
      [attr.title]="valueTooltip != 'N/A' ? valueTooltip : null">

      <ng-container *ngIf='link;then linkedValue else rawValues'></ng-container>

      <ng-template #rawValues>
        <ng-container *ngTemplateOutlet='Array.isArray( value ) ? arrayData : tValue; context: { value: value }'>
        </ng-container>
      </ng-template>

      <ng-template #arrayData let-value='value'>
        <img *ngIf='valueIcon && !valueIconSize' [src]='valueIcon' alt="{{valueIcon}}" />
        <img *ngIf='valueIcon && valueIconSize' [src]='valueIcon' alt="{{valueIcon}}" width="{{valueIconSize}}"
          height="{{valueIconSize}}" />
        <ng-container *ngFor='let item of value; let i = index'>
          <span *ngIf=' i > 0'>, </span>
          <span *ngIf='!( interact.observers.length && enableInteract )'>
            <ng-container *ngTemplateOutlet='tValue; context: { value: item }'></ng-container>
          </span>
          <a *ngIf='interact.observers.length && enableInteract' class='btn btn-link p-0 btn-sm'
            (click)='interact.emit( item )'>
            <ng-container *ngTemplateOutlet='tValue; context: { value: item }'></ng-container>
          </a>
        </ng-container>
      </ng-template>

      <ng-template #tValue let-value='value'>
        <ng-container *ngIf='lock'>
          <span class="freemium-lock">
            <i class="fa fa-lock"></i>
          </span>
        </ng-container>
        <ng-container *ngIf='!lock'>
          <ng-container *ngIf='!_valueContent'>
            <ng-container *ngIf='valueIcon && value !== "N/A"'>
              <img class="mr-1" *ngIf="valueIconSize" [src]='valueIcon' alt="{{valueIcon}}" width="{{valueIconSize}}"
                height="{{valueIconSize}}" />
              <img class="mr-1" *ngIf="!valueIconSize" [src]='valueIcon' alt="{{valueIcon}}" />
            </ng-container>
            <span>{{value}}</span>
          </ng-container>
          <ng-container *ngIf='_valueContent'>
            <ng-content></ng-content>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #linkedValue>
        <ng-container *ngIf='isAbsoluteLink'>
          <a target='_blank' class='btn btn-link p-0 btn-sm' href='{{link}}'>

            <ng-container *ngTemplateOutlet='tValue; context: { value: value }'></ng-container>
            <i class='fa fa-external-link ml-1' aria-hidden='true'></i>
          </a>
        </ng-container>

        <ng-container *ngIf='!isAbsoluteLink'>
          <a class='btn btn-link p-0 btn-sm' [routerLink]='link' [queryParams]='linkParams'>

            <ng-container *ngTemplateOutlet='tValue; context: { value: value }'></ng-container>
          </a>
        </ng-container>

      </ng-template>

    </span>

    <ng-container *ngIf='suggestionConfig != null && !lock'>
      <suggest-feedback [metricPrettyName]='label' [metricId]='suggestionConfig.metricId' [type]='suggestionConfig.type'
        [id]='suggestionConfig.id'></suggest-feedback>
    </ng-container>
  </div>
</div>